import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs/manage-license';

const list = (merchantId, page = 1, pageSize = 10000) => {
	return Client.get(`${baseUrl}/licenses`, {
		merchantId,
		page,
		pageSize,
	});
};

export default { list };
